import { useState } from 'react';
import { DevToolsMenu } from '@/components/composed/DevToolsMenu/DevToolsMenu';
import { DevelopmentOnly } from '@/components/DevelopmentOnly';
import { KeyboardShortcutsModal } from '@/components/modals/KeyboardShortcutsModal';
import { useAuth } from '@/services/auth';
import { useShouldShowAdmin } from '@/utils/admin';
import { isDevelopment } from '@/utils/environment';

/**
 * System-level footer controls
 * Always visible, independent of page content
 *
 * Contains:
 * - DevTools menu (development environment only)
 * - Admin tools (when user is admin)
 * - Keyboard shortcuts button
 */
export function FooterSystemControls(): JSX.Element {
  const { isAdmin } = useAuth();
  const shouldShowAdmin = useShouldShowAdmin();
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);

  return (
    <>
      <div className="flex items-center gap-4 pr-4 border-l border-border pl-4">
        {/* Dev Tools dropdown - only in development, includes admin tools when applicable */}
        <DevelopmentOnly>
          <DevToolsMenu
            shouldShowAdmin={shouldShowAdmin}
            isAdmin={isAdmin}
            isDevelopmentEnv={isDevelopment()}
          />
        </DevelopmentOnly>

        {/* Keyboard shortcuts button */}
        <button
          onClick={() => setShowKeyboardShortcuts(true)}
          className="hover:text-foreground transition-colors"
          aria-label="Show keyboard shortcuts"
          title="Keyboard shortcuts (Shift+/)"
        >
          ?
        </button>
      </div>

      {/* Keyboard shortcuts modal */}
      <KeyboardShortcutsModal
        open={showKeyboardShortcuts}
        onClose={() => setShowKeyboardShortcuts(false)}
      />
    </>
  );
}
